import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss']
})
export class LibraryComponent implements OnInit {    
  selectedLanguage = "";
  library_data: any[] = [];

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchData();
  }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "Library API Response");

      if (response?.data) {
        // Filter for Library category
        this.library_data = response.data.filter(
          (x: any) => x.ContentCategoryName === "Library"
        );
        console.log(this.library_data, "Filtered Library Data");
      }
    });
  }
}
